import { Entity, PrimaryColumn, Column } from 'typeorm'

@Entity('persistence')
export class Persistence {
  @PrimaryColumn('varchar')
  key!: string

  @Column('text')
  value!: string
}
